import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import BellIcon from '../../v2/icons/BellIcon';
import DocumentIcon from '../../v2/icons/DocumentIcon';
import UserCircleIcon from '../../v2/icons/UserCircleIcon';
import LibraryIcon from '../../v2/icons/LibraryIcon';
import VerticalNav from '../../v2/navs/VerticalNav';
import CodeIcon from '../../v2/icons/CodeIcon';

const Sidebar = ({ activePage }) => {
  const carrierCenterActive = activePage === 'profile';
  const documentsActive = activePage === 'documents';
  const billingActive = activePage === 'billing';
  const notificationsActive = activePage === 'notifications';
  const developerActive = activePage === 'developer';

  const { t } = useTranslation();

  return (
    <VerticalNav>
      <VerticalNav.NavItemWithIcon
        url="/profile"
        active={carrierCenterActive}
        title={titleize(t('PROFILE', { count: 1 }))}
      >
        {(iconClassName) => (
          <UserCircleIcon size="medium" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
      <VerticalNav.NavItemWithIcon
        url="/documents"
        active={documentsActive}
        title={titleize(t('DOCUMENT', { count: 1 }))}
      >
        {(iconClassName) => (
          <DocumentIcon size="medium" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
      <VerticalNav.NavItemWithIcon
        url="/billing"
        active={billingActive}
        title={t('BILLING')}
      >
        {(iconClassName) => (
          <LibraryIcon size="medium" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
      <VerticalNav.NavItemWithIcon
        url="/notifications"
        active={notificationsActive}
        title={titleize(t('NOTIFICATION', { count: 1 }))}
      >
        {(iconClassName) => (
          <BellIcon size="medium" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
      <AuthorizationWrapper excludedRegions={[REGIONS.AP]}>
        <VerticalNav.NavItemWithIcon
          url="/developer"
          active={developerActive}
          title={titleize(t('DEVELOPER', { count: 1 }))}
        >
          {(iconClassName) => (
            <CodeIcon size="medium" className={iconClassName} />
          )}
        </VerticalNav.NavItemWithIcon>
      </AuthorizationWrapper>
    </VerticalNav>
  );
};

Sidebar.propTypes = {
  activePage: PropTypes.string,
};

Sidebar.defaultProps = {
  activePage: 'profile',
};

export default Sidebar;
